import createIcon from '../../createIcon';

/**
 * @component @name ScubaDiving
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMSAxMi41QzEgMTEuNCAxLjkgMTAuNSAzIDEwLjVDNC4xIDEwLjUgNSAxMS40IDUgMTIuNUM1IDEzLjYgNC4xIDE0LjUgMyAxNC41QzEuOSAxNC41IDEgMTMuNiAxIDEyLjVaTTguODkgOS42MUwxMy40MiA4LjRMMTIuNjQgNS41TDguMTEgNi43MUM3LjMxIDYuOTIgNi44MyA3Ljc1IDcuMDUgOC41NUM3LjI3IDkuMzUgOC4wOSA5LjgzIDguODkgOS42MVpNMjAuNSA1LjRMMjMgMi41TDIyIDEuNUwxOSA0LjVMMTcgOC41TDcuNTIgMTEuMzdDNi43IDExLjU3IDYuMTMgMTIuMjYgNi4wMiAxMy4wNUw1LjI0IDE3LjVMMi40IDIxLjNMNCAyMi41TDcgMTguNUw4LjE0IDE1LjM2TDE0IDEzLjVMMTkgMTBMMjAuNSA1LjRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ScubaDiving = createIcon('ScubaDiving', [
  [
    'path',
    {
      d: 'M1 12.5C1 11.4 1.9 10.5 3 10.5C4.1 10.5 5 11.4 5 12.5C5 13.6 4.1 14.5 3 14.5C1.9 14.5 1 13.6 1 12.5ZM8.89 9.61L13.42 8.4L12.64 5.5L8.11 6.71C7.31 6.92 6.83 7.75 7.05 8.55C7.27 9.35 8.09 9.83 8.89 9.61ZM20.5 5.4L23 2.5L22 1.5L19 4.5L17 8.5L7.52 11.37C6.7 11.57 6.13 12.26 6.02 13.05L5.24 17.5L2.4 21.3L4 22.5L7 18.5L8.14 15.36L14 13.5L19 10L20.5 5.4Z',
      key: '14y113',
    },
  ],
]);

export default ScubaDiving;
